import { T_ApiResponse } from "../../globalTypes/GlobalTypes";
import { CSApiService } from "../../redux-store/CSApiService";
import {
  Api_DownloadMotorPolicyDocument,
  Api_FetchPocketInsurancePolicyDocument,
  Api_FetchTravelInsurancePolicyDocument,
  Api_FetchUserProductStatus,
  Api_FetchUserTransactionStatus,
} from "../../utils/ApiEndpoints";
import {
  T_DownloadMotorPolicyDocument_Request,
  T_DownloadMotorPolicyDocument_Response,
  T_FetchInsuranceHoldingDocument_Request,
  T_FetchInsuranceHoldingDocument_Response,
  T_FetchUserProductStatus_Request,
  T_FetchUserProductStatus_Response,
  T_FetchUserTransactionStatus_Request,
  T_FetchUserTransactionStatus_Response,
} from "./Feature_ABCD_Types";

export const ABCDHoldingsApi = CSApiService.injectEndpoints({
  endpoints: (builder) => ({
    fetchUserProductStatus: builder.query<
      T_ApiResponse<T_FetchUserProductStatus_Response>,
      T_FetchUserProductStatus_Request
    >({
      query: (request) => ({
        url: `${Api_FetchUserProductStatus}`,
        method: "POST",
        body: request,
      }),
    }),
    fetchUserTransactionStatus: builder.query<
      T_ApiResponse<T_FetchUserTransactionStatus_Response>,
      T_FetchUserTransactionStatus_Request
    >({
      query: (request) => ({
        url: `${Api_FetchUserTransactionStatus}`,
        method: "POST",
        body: request,
      }),
    }),
    downloadMotorPolicyDocument: builder.query<
      T_ApiResponse<T_DownloadMotorPolicyDocument_Response>,
      T_DownloadMotorPolicyDocument_Request
    >({
      query: (request) => ({
        url: `${Api_DownloadMotorPolicyDocument}`,
        method: "POST",
        body: request,
      }),
    }),
    fetchPocketInsuranceDocument: builder.query<
      T_ApiResponse<T_FetchInsuranceHoldingDocument_Response>,
      T_FetchInsuranceHoldingDocument_Request
    >({
      query: (request) => ({
        url: `${Api_FetchPocketInsurancePolicyDocument}`,
        method: "POST",
        body: request,
      }),
    }),
    fetchTravelInsuranceDocument: builder.query<
      T_ApiResponse<T_FetchInsuranceHoldingDocument_Response>,
      T_FetchInsuranceHoldingDocument_Request
    >({
      query: (request) => ({
        url: `${Api_FetchTravelInsurancePolicyDocument}`,
        method: "POST",
        body: request,
      }),
    }),
  }),
});

export const {
  useLazyFetchUserProductStatusQuery,
  useLazyFetchUserTransactionStatusQuery,
  useLazyDownloadMotorPolicyDocumentQuery,
  useLazyFetchPocketInsuranceDocumentQuery,
  useLazyFetchTravelInsuranceDocumentQuery,
} = ABCDHoldingsApi;
